<template>
<el-dialog class="recharge-dialog" v-model="show" :show-close="true">
  <div slot="title" class="dialog-header">
    <div class="tab-list">
      <div :class="['tab-li', {'active': tab.tabIndex === currentTab}]" @click="changeTab(tab.tabIndex)" v-for="(tab, index) in tabList" :key="tab.tabIndex">{{tab.title}}<span>{{tab.desc}}</span></div>
    </div>
  </div>

  <div class="dialog-content" v-if="currentTab === 0">
    <div class="recharge-list">
      <div class="amount-rest">账户余额<span class="amount-number">￥{{peerInfo.balance_amount | price}}</span></div>
      <div class="recharge-header">
        <div class="title">
          选择充值金额<span class="desc">(可用于平台保险、签证办理，通用于官网、小程序使用)</span>
        </div>
        <div class="recharge-tips">
          充值说明

          <el-tooltip placement="bottom" popper-class="el-tooltip-recharge-tips">
            <div slot="content" class="el-tooltip-recharge-tips-content">
              <template v-if="chargeCouponArr && chargeCouponArr.length > 0">
                <div  class="content-item" v-for="(item, index) in chargeCouponArr" :key="index">
                  <div>• 充值{{item.recharge_amount / 100}}元送{{item.total_reduce / 100}}元优惠券</div>
                  <div>
                    赠送方式：
                    <span v-if="item.reward_way === 0">一次性赠送；</span>
                    <span v-if="item.reward_way === 1">每周赠送{{item.total_reduce / 100 /  item.reward_times}}元，连续赠送{{item.reward_times}}周；</span>
                    <span v-if="item.reward_way === 2">每月赠送{{item.total_reduce / 100 /  item.reward_times}}元，连续赠送{{item.reward_times}}个月；</span>
                  </div>
                  <div>
                    优惠券包括：
                    <span class="coupon-content" v-for="(coupon, index) in item.coupons" :key="index">
                      <span v-if="coupon.coupon_type_id === 1">{{coupon.cash_reduce / 1000}}折券</span>
                      <span v-else-if="coupon.coupon_type_id === 0">{{coupon.cash_reduce / 100}}元券</span>
                      <span v-if="coupon.reach_reduce">满{{coupon.reach_reduce / 100}}元使用</span>
                      <span v-else>无门槛</span>
                      <span>{{(index ===  item.coupons.length - 1) ? '；' : '，'}}</span>
                    </span>
                  </div>
                  <br />
                </div>
              </template>

              • 充值后余额仅能用于上上签平台下的产品与服务，暂不支持兑换现金，不支持转账交易，不支持退款；上上签平台包含官网与小程序，服务包含签证办理、保险服务等；
              <br /><br />
              • 请按活动指定金额充值，非指定金额不享受优惠券赠送；每次充值都可获赠，优惠券有效期14天；
              <br /><br />
              • 如在充值过程中遇到任何问题，请及时与客服联系
              <br /><br />
              • 上上签保留对该活动的最终解释权
            </div>
            <img class="icon" src="../../assets/imgs/insurance-new/icon-query.png" alt="">
          </el-tooltip>
        </div>

      </div>
      <!-- 充值送卷 -->
      <div class="recharge-content" >
        <template v-if="chargeCouponArr && chargeCouponArr.length > 0">
          <div
            class="recharge-item"
            :class="{ active: selectedMoney == v.recharge_amount }"
            @click="chooseMoney(v.recharge_amount)"
            v-for="(v, index) in chargeCouponArr"
            :key="index"
          >
            <div class="money-box">
              <div class="money">￥<span>{{v.recharge_amount / 100}}</span></div>
            </div>
            <div class="charge-coupon">
              <div v-if="v.show_type === 2">送{{v.min_discount / 1000}}折优惠券</div>
              <div v-else-if="v.show_type === 1">送{{v.total_reduce / 100}}元优惠券</div>
            </div>
          </div>
        </template>
        <!-- 没有充值送卷活动的时候 -->
        <template v-else>
          <div
            class="recharge-item"
            :class="{ active: selectedMoney == v }"
            @click="chooseMoney(v)"
            v-for="(v, index) in recharge_amount"
            :key="index"
          >
            <div class="money-box">
              <div class="money">￥<span>{{v / 100}}</span></div>
            </div>
          </div>
        </template>
        <div
          class="recharge-item other-item"
          :class="[otherSelected ? !otherValidate && !otherInputFocus ? 'error' : 'active' : '']"
          @click="handleSelectOther"
        >
          <div class="input-box">
            <div class="no-select" v-if="!otherSelected">其他金额</div>
            <div class="inner-input" v-else>
              <el-input ref="otherInput" placeholder="输入金额" v-model="otherMoney" :maxlength="7" @focus="inputFocus" @blur="inputBlur"></el-input>
              <div class="currency">￥</div>
            </div>
          </div>
          <div v-if="chargeCouponArr && chargeCouponArr.length > 0" class="charge-coupon">无赠送</div>
          <div class="err" v-if="otherSelected && !otherInputFocus && !otherValidate">{{otherMoney ? '请输入正确的金额' : '请输入充值金额'}}</div>
        </div>
      </div>
    </div>
    <div class="pay-box">
      <div class="pay-way">
        <div class="way-item" :class="{active: key === selectPayWayStr}" v-for="(value, key) in payWay" :key="key" @click="changePayWay(key)">
          <img class="item-icon" :src="$importImage(`payway${key.split('_')[1]}.png`)" alt="">
          <div class="text">{{value}}</div>
        </div>
      </div>
      <!-- 微信、支付宝 -->
      <div class="pay-content wx-pay" v-if="isWeixinAndAlipay">
        <div class="qrcode-box">
          <qrcode :options="qrOption" v-if="qrcodeUrl"></qrcode>
          <div class="nodata" v-else-if="!currMoney">
            <img class="icon" src="../../assets/imgs/insurance-new/no-qrcode-icon.png" alt="">
            <div class="text">请输入充值金额</div>
          </div>
          <div class="pay-error" v-else-if="qrcodeUrlError">
            <div class="pay-error-text">加载失败</div>
            <el-button class="pay-error-refresh" type="primary" :loading="getPayloading" @click="refreshPayUrl">点击刷新</el-button>
          </div>
        </div>
        <div class="price-box">
          <div class="price-label">应付金额:</div>
          <div class="price-value"><span>￥</span>{{currMoney / 100}}</div>
          <div class="tips">使用微信/支付宝扫码付款</div>
        </div>
      </div>
       <!-- 银行卡支付、企业网银 -->
      <div class="pay-content card-pay" v-if="selectPayWay === 15 || selectPayWay === 16">
        <div class="price-label">应付金额:</div>
        <div class="price-value"><span>￥</span>{{currMoney / 100}}</div>
        <el-button @click="submitUnionForm" :disabled="!postUrl" type="primary" class="pay-btn">前往付款</el-button>
      </div>
    </div>
    <!-- 是否立即支付 -->
    <div v-if="showPayNowCheckbox" class="pay-now-box">
      <el-checkbox v-model="isPayNow">充值并支付订单</el-checkbox>
    </div>
  </div>
  <public-audit v-if="currentTab === 1" :peerInfo="peerInfo" @close="auditSuccessHandle"></public-Audit>
</el-dialog>
</template>
<script>
import qrcode from 'qrcanvas-vue';
import { mapState, mapMutations } from 'vuex';
import _ from 'lodash';
import User from '../../libs/user';
import Http from '../../libs/http';
import dateUtils from '../../libs/date-util';
import utils from '../../libs/utils';
import publicAudit from './public-audit.vue';

export default {
  components: {
    qrcode,
    publicAudit,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    from: {
      type: String,
      default: '',
    },
    showPayNowCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: this.value,
      User,
      peerInfo: {},
      chargeCouponArr: [], // 充值赠送优惠券数据
      activityTime: '', // 活动时间
      selectedMoney: 0, // 当前选择的输入框的钱
      otherSelected: false, // 是否选择了其他输入框
      otherMoney: '', // 其他充值输入框value
      otherInputFocus: false, // 其他充值输入框焦点
      payWay: { // 充值方式
        payType_14: '微信/支付宝',
        payType_15: '银行卡支付',
        payType_16: '企业网银',
      },
      selectPayWayStr: 'payType_14',
      qrcodeUrl: '', // 充值二维码URL
      postUrl: '', // 银联充值表单提交url
      qrcodeUrlError: false,
      getPayloading: false, // 加载中
      currentTab: 0,
      showRechargeContent: false,
      showPubAuditContent: false,
      tabList: [
        {
          tabIndex: 0,
          title: '在线充值',
          desc: '实时到账',
        },
        {
          tabIndex: 1,
          title: '对公汇款',
          desc: '1个工作日到账',
        },
      ],
      isPayNow: true, // 是否立即支付
    };
  },
  watch: {
    value() {
      this.show = this.value;
      this.init();
    },
    show() {
      this.$emit('input', this.show);
    },
    currMoney() {
      if (this.isMoreFiftyThousand) {
        utils.msg.warning('最大输入50000');
      }
      this.doRecharge();
    },
  },
  computed: {
    ...mapState('config/', [
      'recharge_amount',
    ]),
    qrOption() {
      return {
        data: this.qrcodeUrl,
        size: 360,
        correctLevel: 'Q',
      };
    },
    // 校验其它金额
    otherValidate() {
      return this.otherMoney && /^\d+(.{0,1}\d{0,2}){0,1}$/.test(this.otherMoney);
    },
    currMoney() {
      if (this.otherSelected) {
        return this.otherMoney && this.otherValidate && !this.isMoreFiftyThousand ? utils.mul(this.otherMoney, 100) : 0;
      }
      return this.selectedMoney;
    },
    isMoreFiftyThousand() {
      return utils.mul(this.otherMoney, 100) > 5000000;
    },
    selectPayWay() {
      return +this.selectPayWayStr.split('_')[1];
    },
    isWeixinAndAlipay() {
      const payTypeList = [14];
      return payTypeList.includes(this.selectPayWay);
    },
  },
  created() {
    // 如果是从银联回跳回来的时候
    const query = this.$route.query || {};
    if (query.paySuccess === '1') {
      query.paySuccess = '';
      this.$router.replace({ query });
      this.rechargeSuccessHandle();
      return;
    }
    this.init();
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    init() {
      if (!this.show) return;
      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX();
        return;
      }
      this.getUserData();
      this.getChargeCouponData();
    },
    getUserData() {
      // 获取同业信息
      Http.post('/visa_peer_query')
        .then((data) => {
          this.peerInfo = data;
        }).catch((e) => {
          if (e) console.log(e);
        });
    },
    // 切换tab
    changeTab(val) {
      if (val === 0) {
        this.currentTab = 0;
      } else {
        this.currentTab = 1;
      }
    },
    // 加载充值赠送优惠券数据
    getChargeCouponData() {
      return Http.post('/sys/recharge_activity', {})
        .then((data) => {
          if (data.rules) {
            this.chargeCouponArr = data.rules;

            this.chooseMoney(data.rules[1].recharge_amount);
            // 活动时间
            // 活动结束时间年份小于 2035 时表示非长期活动
            if (parseInt(data.end_time.slice(0, 4), 10) < 2035) {
              this.activityTime = `${dateUtils.formatDateWithoutYear(data.begin_time)} - ${dateUtils.formatDateWithoutYear(data.end_time)}`;
            }
          } else {
            // 没有活动，也默认选择第二档
            this.chooseMoney(this.recharge_amount[1]);
          }
        }).catch((e) => {
          if (e) console.log(e);
        });
    },
    chooseMoney(amount) {
      this.selectedMoney = +amount;
      this.otherSelected = false;
      this.otherMoney = '';
    },
    changePayWay(way) {
      this.selectPayWayStr = way;
      this.getPayloading = true;
      this.doRecharge();
    },
    // 刷新url
    refreshPayUrl() {
      this.getPayloading = true;
      this.doRecharge();
    },
    handleSelectOther() {
      if (!this.otherSelected) {
        this.otherSelected = true;
        this.selectedMoney = 0;
        this.qrcodeUrl = '';
      }
      this.$nextTick(() => {
        this.$refs.otherInput.$refs.input.focus();
      });

    },
    inputFocus() {
      this.otherInputFocus = true;
    },
    inputBlur() {
      this.otherInputFocus = false;
    },
    // 获取神策来源，用于给
    getShenceRefer() {
      let refer = 0;
      const referMap = {
        orderComfirm: {
          backNum: 1,
          meanning: '确认订单',
        },
        sfpickup: {
          backNum: 2,
          meanning: '后置顺丰',
        },
        interviewChange: {
          backNum: 3,
          meanning: '修改赴馆时间',
        },
        orderDiffPay: {
          backNum: 4,
          meanning: '补缴费用',
        },
        insurancePay: {
          backNum: 5,
          meanning: '保险支付',
        },
        changeInsurance: {
          backNum: 6,
          meanning: '修改保期',
        },
        invoice: {
          backNum: 6,
          meanning: '开发票',
        },
      };
      if (this.from) {
        if (referMap[this.from]) {
          refer = referMap[this.from].backNum;
        }
      }
      return refer;
    },
    doRecharge() {
      // 充值切换就先清空
      this.qrcodeUrl = '';
      this.postUrl = '';
      this.qrcodeUrlError = false;
      // 真正的充值请求方法
      this.handlerRechargeRequest();
    },
    handlerRechargeRequest: _.debounce(function () {
      this.qrcodeUrl = '';
      this.postUrl = '';
      const cash_fee = this.currMoney; // 充值金额
      const payment_type = +this.selectPayWay;

      // 检查是否填写充值金额与支付方式
      if (!cash_fee) return;
      // 银联回调的前端url
      const frontUrl = `${window.location.href}${window.location.href.indexOf('?') > -1 ? '&' : '?'}paySuccess=1`;
      // 清除一下旧的定时器
      this.timer && clearInterval(this.timer);
      Http.post('/peer_recharge', {
        cash_fee,
        payment_type: +payment_type,
        front_url: (payment_type === 15 || payment_type === 16) ? frontUrl : undefined,
        referrer: this.getShenceRefer(),
      }).then((data) => {
        this.rechargeId = data.recharge_id;
        if (data.qrcode_url) {
          if ([14].indexOf(payment_type) > -1) {
            // 微信/支付宝支付弹出二维码
            this.qrcodeUrl = data.qrcode_url;
          } else {
            // 银联支付
            this.postUrl = data.qrcode_url;
          }
          
          this.resultGetQrcode();
        } else {
          utils.msg.warning('数据异常，请稍后重新尝试');
        }
        this.getPayloading = false;
      }, () => {
        this.qrcodeUrl = '';
        this.getUserData();
        this.submiting = false;
        this.getPayloading = false;
        this.qrcodeUrlError = true;
      });
    }, 500),
    submitUnionForm() {
      window.open(this.postUrl);
    },
    // 循环查询充值结果
    resultGetQrcode() {
      this.timer && clearInterval(this.timer);
      // 循环查询结果
      this.timer = setInterval(() => {
        Http.post('/peer_recharge_query', { recharge_id: this.rechargeId })
          .then((data) => {
            if (data.result === 1) {
              this.rechargeSuccessHandle(data);
              clearInterval(this.timer);
            }
          })
          .catch((e) => {
            if (e) console.log(e);
          });
      }, 1500);
    },
    // 充值成功之后的处理
    rechargeSuccessHandle(data = {}) {
      utils.msg.success('充值成功');
      setTimeout(() => {
        this.show = false;
        this.$emit('recharge-success', {
          isPayNow: this.showPayNowCheckbox ? this.isPayNow : undefined,
          isGiveCoupon: !!data.is_give_coupon, // 是否赠送优惠券
        });
      }, 500);
      
    },
    // 对公汇款审核成功后
    auditSuccessHandle(type) {
      if (type === 'success') {
        utils.msg.success('提交成功后，财务人员将在一个工作日内完成审核确认。');
      }
      this.show = false;
      this.$emit('audit-success', type);
    },
  },
};
</script>
<style scoped lang="less">
.recharge-dialog{
  /deep/ .el-dialog{
    width: 689px;
    border-radius: 4px;
    box-shadow:0px 8px 12px 0px rgba(57,61,70,0.06);
    overflow: hidden;
    background: transparent;
    .el-dialog__header{
      display: flex;
      align-items: center;
      padding: 0 24px 0 32px;
      height: 60px;
      box-shadow:0px 8px 12px 0px rgba(57,61,70,0.06);
      background: #2F333D;
      .dialog-header{
        flex-grow: 1;
        color: #E9EEF2;
        font-size: 24px;
        line-height: 20px;
        font-weight: 600;
        // span{
        //   font-size: 12px;
        //   line-height: 1;
        //   color: #DEE2E6;
        //   font-weight: 400;
        //   margin-right: 8px;
        // }
        .tab-list{
          display: flex;
          justify-content: flex-start;
          padding: 0 32px;
          gap: 52px;
          .tab-li{
            font-size: 16px;
            color: #fff;
            font-weight: 500;
            line-height: 56px;
            display: flex;
            align-items: center;
              border-bottom: 4px solid transparent;
            >span{
              font-size: 10px;
              line-height: 14px;
              padding: 2px 8px;
              border-radius: 2px;
              background: rgba(255, 255, 255, 0.15);
              display: inline-block;
              margin-left: 8px;
            }
            &.active{
              border-bottom: 4px solid #599FFF;
            }
            &:hover{
              cursor: pointer
            }
          }
        }
      }
      .el-dialog__headerbtn{
        flex-shrink: 0;
        .el-dialog__close{
          color: #91999F;
          font-size: 14px;
        }
      }
    }
    .el-dialog__body{
      background: #fff;
      padding: 32px;
      .dialog-content{
        line-height: 1;
        .recharge-list{
          .amount-rest{
            padding:0 0 32px 0;
            font-size: 16px;
            font-weight: 500;
            color: #2F333D;
            .amount-number{
              font-family: DINPro, DINPro;
              font-weight: 500;
              font-size: 24px;
              color: #FF8033;
              line-height: 20px;
              text-align: left;
              font-style: normal;
              padding-left: 8px;
            }
          }
          .recharge-header{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .title{
              font-size: 16px;
              color: #2F333D;
              font-weight: 600;
              .desc{
                font-weight: 400;
                color: #91999F;
                font-size: 12px;
                margin-left: 4px;
              }
            }
            .recharge-tips{
              display: flex;
              align-items: center;
              color: #2F333D;
              font-size: 12px;
              .icon{
                width: 16px;
                height: 16px;
                margin-left: 3px;
              }
            }
          }
          .recharge-content{
            margin-top: 24px;
            display: flex;
            .recharge-item{
              width: 112px;
              margin-right: 16px;
              display: flex;
              flex-direction: column;
              border: 1px solid #DEE2E6;
              border-radius:2px;
              cursor: pointer;
              position: relative;
              &:last-child{
                margin-right: 0;
              }
              &:nth-child(2){
                &::before{
                  content: "";
                  width: 59px;
                  height: 27px;
                  background: url(../../assets/imgs/insurance-new/recharge-recommend-2.png) no-repeat center / 100% 100%;
                  position: absolute;
                  left: -5px;
                  top: -4px;
                }
              }
              &:nth-child(4){
                &::before{
                  content: "";
                  width: 59px;
                  height: 27px;
                  background: url(../../assets/imgs/insurance-new/recharge-discounts-2.png) no-repeat center / 100% 100%;
                  position: absolute;
                  left: -5px;
                  top: -4px;
                }
              }
              &.active{
                border: 1px solid #599FFF;
                .charge-coupon{
                  background: #F3F8FF;
                  color: #599FFF;
                }
                &::after{
                  content: "";
                  position: absolute;
                  right: -1px;
                  bottom: -1px;
                  width: 24px;
                  height: 24px;
                  background: url(../../assets/imgs/insurance-new/icon-select.png) no-repeat center / 100% 100%;
                }
              }
              .money-box{
                height: 88px;
                display: flex;
                align-items: center;
                justify-content: center;
                .money{
                  display: flex;
                  align-items: baseline;
                  color: #2F333D;
                  font-weight: 600;
                  font-size: 17px;
                  span{
                    font-size: 30px;
                    letter-spacing: -1.5px;
                  }
                }

              }
              .charge-coupon{
                height: 32px;
                border-radius:0px 0px 2px 2px;
                background: #FFF8EF;
                color: #AA6D55;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              &.other-item{
                &.active{
                  .charge-coupon{
                    background: #F3F8FF;
                  }
                }
                &.error{
                  border: 1px solid #FF6464;
                }
                .input-box{
                  height: 88px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  .no-select{
                    color: #2F333D;
                    font-size: 14px;
                    font-weight: 600;
                  }
                  .inner-input{
                    width: 80px;
                    color: #2F333D;
                    font-size: 16px;
                    font-weight: 600;
                    position: relative;
                    .el-input{
                      .el-input__inner{
                        border: none;
                        padding: 0;
                        padding-left: 14px;
                        border-bottom: 1px solid #E9EEF2;
                        border-radius: 0;
                        font-size: 16px;
                        font-weight: 600;
                        height: 24px;
                        letter-spacing: -1px;
                        &:focus{
                          border-bottom: 1px solid #599FFF;
                        }
                        &::placeholder{
                          font-size: 14px;
                          color: #C9CDD1;
                        }
                      }
                    }
                    .currency{
                      font-size: 14px;
                      color: #2F333D;
                      position: absolute;
                      left: 0;
                      top: 5px;
                    }
                  }

                }
                .charge-coupon{
                  background: #FAFBFC;
                  color: #91999F;

                }
                .err{
                  position: absolute;
                  color: #FF6464;
                  font-size: 12px;
                  line-height: 18px;
                  left: 0;
                  bottom: -20px;
                  width: 100%;
                  text-align: center;
                }
              }
            }

          }
        }
        .pay-box{
          margin-top: 32px;
          background: #fff;
          border: 1px solid #DEE2E6;
          display: flex;
          .pay-way{
            width: 140px;
            display: flex;
            flex-direction: column;
            .way-item{
              background: #F3F6F9;
              height: 52px;
              padding-left: 25px;
              display: flex;
              align-items: center;
              cursor: pointer;
              &.active{
                background: #fff;
                .text{
                  color: #2F333D;
                  font-weight: 600;
                }
              }
              .item-icon{
                width: 16px;
                margin-right: 4px;
              }
              .text{
                color: #5F666E;
                font-size: 14px;
              }
            }
          }
          .pay-content{
            flex-grow: 1;
            &.wx-pay{
              padding: 32px 0 32px 64px;
              display: flex;
              .qrcode-box{
                flex-shrink: 0;
                width: 140px;
                height: 140px;
                background: url(../../assets/imgs/insurance-new/qrcode-bg.png) no-repeat center / 100% 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                canvas{
                  width: 120px;
                  height: 120px;
                }
                .nodata{
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  .icon{
                    width: 26px;
                    height: 26px;
                  }
                  .text{
                    margin-top: 8px;
                    color: #91999F;
                    font-size: 12px;
                  }
                }
                .pay-error{
                  width: 100%;
                  height: 100%;
                  background: rgba(0, 0, 0,0.65);
                  color: #fff;
                  font-size: 14px;
                  position: absolute;
                  top: 0px;
                  left: 0px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  flex-direction: column;
                }
                .pay-error-refresh{
                  margin-top: 16px;
                }
              }
              .price-box{
                margin-left: 24px;
                padding-top: 12px;
                .price-label{
                  color: #2F333D;
                  font-size: 14px;
                  line-height: 20px;
                  margin-bottom: 8px;
                }
                .price-value{
                  color: #FF8033;
                  display: flex;
                  align-items: baseline;
                  font-size: 34px;
                  letter-spacing: -1px;
                  font-weight: 600;
                  span{
                    font-size: 18px;
                  }
                }
                .tips{
                  margin-top: 12px;
                  color: #5F666E;
                  font-size: 12px;
                }
              }
            }
            &.card-pay{
              padding: 44px 0 32px 64px;
              .price-label{
                color: #2F333D;
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 8px;
              }
              .price-value{
                color: #FF8033;
                display: flex;
                align-items: baseline;
                font-size: 34px;
                letter-spacing: -1px;
                font-weight: 600;
                span{
                  font-size: 18px;
                }
              }
              .pay-btn{
                margin-top: 12px;
                width:120px;
                height:36px;
                border-radius:2px;
                background: #599FFF;
                font-size: 16px;
                color: #fff;
                padding: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 1;
                &.is-disabled{
                  background: #BCD8FF;
                  border: 1px solid #BCD8FF;
                }
              }

            }
          }
        }

        .pay-now-box{
          display: flex;
          justify-content: flex-end;
          margin-top: 16px;
        }
      }
    }
  }
}
</style>
<style lang="less">
.el-tooltip-recharge-tips{
  &.is-dark{
    background:rgba(47,51,61,0.94);
  }
  width: 326px;
  padding: 12px;
  line-height: 17px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/recharge-dialog.vue